import { useCallback } from 'react';
import { get } from 'lodash';

function useOpenSupportWidgetEventHandler() {
  const openSupportWidget = useCallback((e) => {
    const { target } = e;
    const isReachLink = Boolean(target.closest('.reach-to-support'));

    if (isReachLink) {
      if (window.hubspot_live_messages_running) {
        const widget = get(window, 'window.HubSpotConversations.widget');
        if (widget) {
          widget.open();
        }
      }
    }
  }, []);

  return openSupportWidget;
}

export default useOpenSupportWidgetEventHandler;
